import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "grid__content" }
const _hoisted_6 = { class: "grid__title--sub" }
const _hoisted_7 = { class: "grid__title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "button button__slide" }, "explore", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    "data-aos": "fade-up",
    "data-aos-delay": "0",
    class: _normalizeClass(_ctx.computedData.classes),
    href: _ctx.link,
    style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor})
  }, [
    (_ctx.backgroundType === 'image')
      ? (_openBlock(), _createElementBlock("picture", _hoisted_2, [
          _createElementVNode("source", {
            srcset: _ctx.oneColImage,
            media: "(max-width: 768px)"
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            decoding: "async",
            src: _ctx.computedData.imageSrc
          }, null, 8, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.company), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.title), 1),
      _hoisted_8
    ])
  ], 14, _hoisted_1))
}